// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Xbl9p","inputWrap":"CustomTip_inputWrap__36VyZ"};